import axios from 'axios'
export const LOAD_PAIRS = 'load_pairs';
export const LOAD_PERFORMACE = 'load_performance';
export const LOAD_PERFORMACE_DATES = 'load_performance_dates';
export const SET_INDEX = 'set_index';
export const SET_PAIR = 'set_pair';
export const SET_DATE = 'set_date';
export const SET_CATEGORY = 'set_category';
export const SET_PERIOD = 'set_period';
export const SET_SORT = 'set_sort';
export const SORT_DATA = 'sort_data';
export const SET_CURRENT_URL = 'set_current_url';
export const SET_URL_DATE = 'set_url_date';
export const SET_URL_PERIOD = 'set_url_period';
export const SET_URL_CATEGORY = 'set_url_category';


export function loadPairs() {
  return async (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/pairs/`
    };
    return axios(request)
      .then(response => {
        dispatch({ type: LOAD_PAIRS, payload: response.data });
        var idx = window.location.search.split('index=')[1] || '';
        if (idx !== '') {
          dispatch(setIndex(idx));
        }
      })
      .catch(error => {
        console.log(error)
      });
  }
}

export function loadPerformance() {
  return async (dispatch, getState) => {
    let params = {
      id: getState().performance.pair.uu_attribution_id,
      date: getState().performance.date
    };
    let urlDate = getState().performance.urlDate;
    if (urlDate.length > 0) {
      params.date = urlDate;
    }
    if (window.portfolioMapper) {
      if (window.portfolioMapper.clientEmail) {
        params.email = window.portfolioMapper.clientEmail
      }
      if (window.portfolioMapper.wtRegion) {
        params.wtRegion = window.portfolioMapper.wtRegion
      }
    }

    const request = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/`,
      params: params
    };

    try {
      const response = await axios(request);
      dispatch({ type: LOAD_PERFORMACE, payload: response.data.results });
      dispatch({ type: SORT_DATA });
      return Promise.resolve();
    } catch (error) {
      console.log(error);
      return Promise.reject();
    }
  };
}


// loads the fund details excel
export function loadAttributionExcel() {
  let advisorEmail = '';
  if (window.portfolioMapper) {
    if (window.portfolioMapper.clientEmail) {
      advisorEmail = window.portfolioMapper.clientEmail;
    }
  }

  return (dispatch, getState) => {
    let params = {
      id: getState().performance.pair.uu_attribution_id,
      date: getState().performance.date,
      advisorEmail: advisorEmail
    };

    //params += `advisorEmail=${advisorEmail}`;
    console.log('params', params)
    let urlDate = getState().performance.urlDate
    if (urlDate.length > 0) {
      params.date = urlDate
    }

    console.log('params', params)
    const request = {
      method: 'GET',
      responseType: 'blob',
      url: `${process.env.REACT_APP_API_URL}/excel/`,
      params: params
    };
    return axios(request)
      .then(response => {
        const fileName = 'Attribution-' + getState().performance.pair.uu_attribution_id.split('_')[0] + '.xlsx';
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
        }
      })
      .catch(error => {
        console.log(error)
      });
  }
}

export function loadPerformanceDates() {
  return async (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/dates/`,
      params: {
        code: `${process.env.REACT_APP_API_CODE}`,
        id: getState().performance.pair.uu_attribution_id
      }
    };
    try {
      const response = await axios(request);
      await Promise.all([
        dispatch({ type: LOAD_PERFORMACE_DATES, payload: response.data }),
        dispatch(loadPerformance()),
        dispatch(updateQueryParams()),
      ]);
    } catch (error) {
      console.log(error);
    }
  };
}


export function setIndex(idx) {
  return async (dispatch, getState) => {
    await Promise.all([
      dispatch({ type: SET_INDEX, payload: idx }),
      dispatch(loadPerformanceDates()),
      dispatch(updateQueryParams()),
      dispatch(saveToGA('Analyze')),
    ]);
  };
}


export function setPair(pair) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PAIR, payload: pair });
    dispatch(loadPerformanceDates());
    dispatch(updateQueryParams());
    dispatch(saveToGA('Analyze'));
  }
}

export function setDate(date) {
  return async (dispatch, getState) => {
    dispatch({ type: SET_DATE, payload: date });
    dispatch({ type: SET_URL_DATE, payload: date });  //set this date so after sort it's avail otherwise overwritten to last date
    dispatch(updateQueryParams());
    dispatch(loadPerformance());
  }
}

export function setCategory(cat) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CATEGORY, payload: cat });
    dispatch({ type: SET_URL_CATEGORY, payload: cat });
    dispatch({ type: SORT_DATA });
    dispatch(updateQueryParams());
    dispatch(saveToGA(cat));
  }
}

export function setPeriod(period) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERIOD, payload: period });
    dispatch({ type: SET_URL_PERIOD, payload: period });
    dispatch({ type: SORT_DATA });
    dispatch(updateQueryParams());
  }
}

export function setSort(column) {
  return (dispatch, getState) => {
    dispatch({ type: SET_SORT, column: column });
    dispatch({ type: SORT_DATA });
  }
}

// Save the run of loaded funds to GA
export function saveToGA(eventAction) {
  return (dispatch, getState) => {
    const e = {
      'eventName': 'index attribution',
      'eventAction': eventAction,
      'eventLabel': getState().performance.pair.uu_attribution_id,
      'type': 'CustomTagEvent'
    };

    if (window.digitalData) {
      if (e.Label !== '') {
        window.digitalData.newEvent(e);
        console.log('digitalData: ', e);
      }
    } else {
      console.log('no digitalData: ', e);
    }
  }
}

export function updateQueryParams() {
  return (dispatch, getState) => {
    if (getState().performance.data) {
      const wtindex = getState().performance.index;
      const pair = getState().performance.pair.uu_attribution_id;
      let date = getState().performance.date;
      const urlPeriod = getState().performance.urlPeriod;
      const urlDate = getState().performance.urlDate;
      const urlCategory = getState().performance.urlCategory;

      if (urlDate.length > 0) {
        date = urlDate
      }
      let newHash = `#index-attribution&index=${wtindex}&id=${pair}&urlDate=${date}&urlCategory=${urlCategory}&urlPeriod=${urlPeriod}`;
      window.history.replaceState(null, null, newHash);
      dispatch({ type: SET_CURRENT_URL, payload: window.location.origin + window.location.pathname + newHash });
    }
  }
}

export function setUrlDate(date) {
  return (dispatch, getState) => {
    dispatch({ type: SET_URL_DATE, payload: date });
    dispatch(updateQueryParams());
  }
}

export function setUrlPeriod(period) {
  return async (dispatch, getState) => {
    dispatch({ type: SET_URL_PERIOD, payload: period });
    dispatch(updateQueryParams());
  }
}

export function setUrlCategory(category) {
  return async (dispatch, getState) => {
    dispatch({ type: SET_URL_CATEGORY, payload: category });
    dispatch(updateQueryParams());
  }
}


// WEBPACK FOOTER //
// ./src/actions/index.js